import { ArrowRight, SearchIcon, X } from 'lucide-react'
import CommonFormField from 'components/form/CommonFormField'
import { SearchFormValues } from '../../types/form'
import { Control } from 'react-hook-form'
import { Button, ChipsItem, ChipsWrapper } from '@wellesley/ui'

type Chip = {
  text: string
  avatarSrc?: string
  show?: boolean
  onClose: () => void
}

type SearchInputProps = {
  value: string
  control: Control<SearchFormValues>
  onKeyDown: (e: React.KeyboardEvent) => void
  submitSearch?: () => void
  onClose: () => void
  onClear?: () => void
  chips?: Chip[]
}

export const SearchInput = ({
  value,
  control,
  onKeyDown,
  submitSearch,
  onClose,
  onClear,
  chips = [],
}: SearchInputProps) => (
  <div className="flex items-center gap-xs">
    <SearchIcon size={20} className="text-gray-900" />
    <div className="flex flex-1 items-center gap-xs">
      {chips.filter((chip) => chip.show).length > 0 && (
        <ChipsWrapper>
          {chips.map((chip, index) => (
            <ChipsItem
              key={index}
              text={chip.text}
              onRemove={chip.onClose}
              avatarSrc={chip.avatarSrc}
            />
          ))}
        </ChipsWrapper>
      )}
      <CommonFormField
        autoFocus={true}
        name="searchInput"
        control={control}
        displayName=""
        onKeyDown={onKeyDown}
        className="flex-1"
        inputClassName="!outline-none !py-none !px-xxxs !hover:outline-none !focus-visible:outline-none !bg-white !focus-visible:bg-white !focus-visible:text-gray-900 !disabled:outline-none !ring-offset-0 !focus-visible:ring-0 !disabled:outline-gray-200"
      />
    </div>
    {value && onClear && (
      <>
        <Button
          onClick={onClear}
          variant="tertiary"
          size="icon_s"
          className="text-gray-400"
        >
          Clear
        </Button>
        <div className="h-6 border-r border-gray-200" />
      </>
    )}
    {submitSearch ? (
      <Button
        onClick={submitSearch}
        variant="secondary"
        size="icon_s"
        className="rounded-sm text-gray-700"
      >
        <ArrowRight size={16} />
      </Button>
    ) : (
      <Button
        onClick={onClose}
        variant="tertiary"
        size="icon_s"
        className="text-gray-400"
      >
        <X size={20} />
      </Button>
    )}
  </div>
)
